import React from 'react';
import "./Display.css";
import "./Cerebri-Sans-Book.ttf";
import "./Cerebri-Sans-Bold.ttf";
import "./Cerebri-Sans-Regular.ttf";
import Logo from "./Standard Logo - Horizontal.svg";
import QRCode from "./AllergensLink.png";
import NCASS_LOGO from "./NCASS-LOGO.jpg";
import FOOD_HYGINE_RATING from "./FHR.svg";
import HeadingGif from './gifs/heading.gif';
import PaymentOptions from './images/paymentOptions.png';
import Category from "./components/Category";
import { candyfloss, donuts, drinks, icecream, lollipops, snacks, toys } from "./items";

const DisplayStatic = () => {
  return (
    <div className="display-container display-static">
      <div className="main-content">
        <img className='heading-gif' src={HeadingGif} alt="Blue Duo heading" />

        <div className="display-carousel">
          <div
            className="display-slide display-slide-menu is-active"
            aria-hidden="false"
          >
            <div className="category-container">
              <div className='container-row'>
                <Category title="Donuts" products={donuts} />
                <Category title="Ice Cream" products={icecream} />
                <Category title="Slush" products={drinks} />
              </div>

              <div className='container-row'>
                <Category title="Popcorn" products={snacks} />
                <Category title="Candyfloss" products={candyfloss} />
                <Category title="Toys" products={toys} />
              </div>

              <div className='container-row'>
                <Category title="Lollipops" products={lollipops} />
                <img
                  className="payment-options"
                  src={PaymentOptions}
                  alt="We accept cash and card payments with no minimum card spend"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom-banner">
        <div className="contact-details">
          <img src={Logo} alt="Blue Duo Catering Logo" className="footer-logo" />
          <p>Email: contact@blueduo.events</p>
          <p>Phone: 01352 372235</p>
          <p>Website: www.blueduo.events</p>
        </div>
        <div className="food-hygine-rating">
          <img src={FOOD_HYGINE_RATING} alt="5 Star Food Hygine Rating" />
        </div>
        <div className="ncass-logo">
          <img src={NCASS_LOGO} alt="NCASS Logo" />
        </div>
        <div className="qr-code">
          <img src={QRCode} alt="Scan for allergen details" />
          <p>Allergy Info</p>
        </div>
      </div>
    </div>
  );
};

export default DisplayStatic;
